import {
  DocumentData,
  QueryDocumentSnapshot,
  and,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import SMS from "../../models/SMS";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Subscription from "../../models/Subscription";
import { IContact } from "@leedpulse-monorepo/interfaces";

async function getAllMessages(contactId: string): Promise<{
  messages: SMS[];
  contact: IContact;
  subscription: Subscription;
}> {
  try {
    const messages: SMS[] = [];
    const db = firestore;
    const messagesCollection = collection(db, FirestoreCollections.sms);
    const contactsCollection = collection(db, FirestoreCollections.contacts);
    const subscriptionsCollection = collection(
      db,
      FirestoreCollections.subscriptions
    );

    const contactDoc = doc(contactsCollection, contactId);
    const contactSnap = await getDoc(contactDoc);
    if (!contactSnap.exists()) {
      throw new GetSMSsFailure("Contact not found", "contact-not-found");
    }
    const contact = contactSnap.data() as IContact;

    const querySubscriptions = query(
      subscriptionsCollection,
      where("api_key", "==", contact.id_api_key)
    );

    const subscriptionsSnap = await getDocs(querySubscriptions);

    let subscription: Subscription | null = null;

    subscriptionsSnap.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
      // We know there is only one subscription per contact
      subscription = Subscription.fromFirestore(doc);
    });

    if (!subscription) {
      throw new GetSMSsFailure(
        "Subscription not found",
        "subscription-not-found"
      );
    }

    const queryMessages = query(
      messagesCollection,
      and(
        where("id_contact", "==", contactId),
        where("id_api_key", "==", contact.id_api_key)
      ),
      orderBy("created", "desc")
    );

    const messagesSnap = await getDocs(queryMessages);

    messagesSnap.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
      const data = doc;
      messages.push(SMS.fromFirestore(data));
    });

    return {
      messages,
      contact,
      subscription,
    };
  } catch (e) {
    console.log("error: ", e);
    throw new GetSMSsFailure();
  }
}

export class GetSMSsFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getAllMessages;
